import config from '../config.json'

export class ConfigService {
  static getConfig () {
    const appConfig: any = { ...config }

    if (!appConfig.msal.auth.auth.redirectUri) {
      appConfig.msal.auth.auth.redirectUri = window.location.origin
    }
    if (!appConfig.msal.auth.auth.postLogoutRedirectUri) {
      appConfig.msal.auth.auth.postLogoutRedirectUri = window.location.origin
    }

    return appConfig
  }
}